import {useNavigate, useParams} from "react-router-dom";
import Sidebar from "../components/Sidebar";
import React, {useEffect, useState} from "react";
import PrintReceiptButton from "../components/PrintReceiptButton";
import {privateApi} from "../api";
import axios from "axios";
import {toast} from "react-toastify";
import AddButton from "../components/AddButton";
import EditButton from "../components/EditButton";
import DateTimeSpan from "../components/DateTimeSpan";
import DeleteButton from "../components/DeleteButton";
import PriceInput from "../components/PriceInput";
import OrderStatusSpan from "../components/OrderStatusSpan";
import WhatsappButton from "../components/WhatsappButton";
import moment from "moment";

type RetrieveOrder = {
    orderId: string;
    description: string;
    customer: CustomerInfo;
    device: DeviceInfo;
    statusHistory: OrderStatusAssociation[];
    workTypes: WorkTypeAssociation[];
    payments: PaymentInfo[];
    replacements: ReplacementAssociation[]
}

type CustomerInfo = {
    customerId: string;
    name: string;
    surname: string;
    phonePrefix: string;
    phoneNumber: string;
    email?: string;
}

type PaymentInfo = {
    paymentId: string;
    amount: number;
    paymentType: string;
    creationTimestamp: string;
}

type DeviceInfo = {
    deviceId: string;
    model: string;
    brand: string;
}

type OrderStatusAssociation = {
    associationId: string;
    status: string;
    creationTimestamp: string;
}

type WorkTypeAssociation = {
    associationId: string;
    workType: string;
}

type ReplacementAssociation = {
    associationId: string;
    description: string;
    amount: number;
}

type WorkTypeObject = {
    id: string;
    name: string;
}

type WorkTypeResponse = {
    status: string;
    code: number;
    message: string;
    workTypes: WorkTypeObject[];
}
type PaymentTypeResponse = {
    status: string;
    code: number;
    message: string;
    types: string[];
}

type ReplacementObject = {
    id: string;
    description: string;
    price: number;
}
type RetrieveReplacementResponse = {
    status: string;
    code: number;
    message: string;
    replacements: ReplacementObject[];
}

type RetrieveStatusesResponse = {
    status: string;
    code: number;
    message: string;
    statuses: StatusInfo[];
}

type StatusInfo = {
    id: string;
    name: string;
}

function OrderView() {
    localStorage.setItem("focus", "ordini")
    const {orderId} = useParams<{ orderId: string }>();

    const [workTypes, setWorkTypes] = useState<WorkTypeObject[]>([]);
    const [paymentTypes, setPaymentTypes] = useState<string[]>([]);
    const [replacements, setReplacements] = useState<ReplacementObject[]>([]);
    const [statuses, setStatuses] = useState<StatusInfo[]>([]);


    const [orderIsLoading, setOrderIdLoading] = React.useState(false);

    const [editWorkTypes, setEditWorkTypes] = React.useState(false);
    const [isWorkTypeModalOpen, setIsWorkTypeModalOpen] = React.useState(false);
    const [workTypeToAdd, setWorkTypeToAdd] = React.useState("");

    const [editPayments, setEditPayments] = React.useState(false);
    const [isEditPaymentModalOpen, setIsEditPaymentModalOpen] = React.useState(false);
    const [paymentTypeToAdd, setPaymentTypeToAdd] = React.useState("");
    const [paymentAmountToAdd, setPaymentAmountToAdd] = React.useState("");

    const [editReplacements, setEditReplacements] = React.useState(false);
    const [isEditReplacementModalOpen, setIsEditReplacementModalOpen] = React.useState(false);
    const [replacementToAdd, setReplacementToAdd] = React.useState("");

    const [editStatusHistory, setEditStatusHistory] = React.useState(false);
    const [isEditStatusModalOpen, setIsEditStatusModalOpen] = React.useState(false);
    const [statusToAdd, setStatusToAdd] = React.useState("");

    const [order, setOrder] = React.useState<RetrieveOrder>();

    const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);

    function isStatusEditable(creationTimestamp: string): boolean {
        const ts = moment.utc(creationTimestamp, "DD-MM-YYYYTHH:mm").local();
        return moment().diff(ts, "seconds") < 120;
    }

    const loadOrder = async () => {
        setOrderIdLoading(true);
        try {
            const res = await privateApi.get<RetrieveOrder>(`/cr-order-manager/v1/order/${orderId}`);
            setOrder(res.data);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setOrderIdLoading(false);
        }
    }

    const loadStatuses = async () => {
        try {
            const res = await privateApi.get<RetrieveStatusesResponse>(`/cr-order-manager/v1/status`);
            setStatuses(res.data.statuses);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const loadWorkTypes = async () => {
        try {
            const res = await privateApi.get<WorkTypeResponse>("/cr-order-manager/v1/workType");

            setWorkTypes(res.data.workTypes ?? []);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    };

    const loadPaymentTypes = async () => {
        try {
            const res = await privateApi.get<PaymentTypeResponse>("/cr-order-manager/v1/payment/type");

            setPaymentTypes(res.data.types ?? []);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    };

    const loadReplacements = async () => {
        try {
            const res = await privateApi.get<RetrieveReplacementResponse>(`/cr-order-manager/v1/device/${order?.device.deviceId}/replacement`);

            setReplacements(res.data.replacements ?? []);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    };

    const addWorkTypeToOrder = async () => {
        if (!workTypeToAdd) return toast.error("Seleziona una lavorazione da aggiungere");
        try {
            const payload = {
                workTypeId: workTypeToAdd
            }
            await privateApi.post(`/cr-order-manager/v1/order/${orderId}/workType`, payload);
            setIsWorkTypeModalOpen(false);
            setWorkTypeToAdd("");
            loadOrder();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setEditWorkTypes(false);
        }
    }

    const addPaymentToOrder = async () => {
        if (!paymentTypeToAdd) return toast.error("Seleziona una tipologia di pagamento da aggiungere");
        if (!paymentAmountToAdd) return toast.error("Inserisci un ammontare per il pagamento");
        try {
            const payload = {
                orderId: orderId,
                paymentType: paymentTypeToAdd,
                amount: parseFloat(paymentAmountToAdd)
            }
            await privateApi.post(`/cr-order-manager/v1/payment`, payload);
            setIsEditPaymentModalOpen(false);
            setPaymentTypeToAdd("");
            setPaymentAmountToAdd("");
            loadOrder();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setEditPayments(false);
        }
    }

    const addReplacementToOrder = async () => {
        if (!replacementToAdd) return toast.error("Seleziona una tipologia di pagamento da aggiungere");

        try {
            const payload = {
                orderId: orderId,
                replacementId: replacementToAdd
            }
            await privateApi.post(`/cr-order-manager/v1/replacement/order`, payload);
            setIsEditReplacementModalOpen(false);
            setReplacementToAdd("");
            loadOrder();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setEditReplacements(false);
        }
    }

    const addStatusToOrder = async () => {
        if (!statusToAdd) return toast.error("Seleziona uno stato da aggiungere");

        try {
            const payload = {
                orderId: orderId,
                statusId: statusToAdd
            }
            await privateApi.post(`/cr-order-manager/v1/order/status`, payload);
            toast.success("Stato aggiunto all'ordine. Hai due minuti per eliminare lo stato")
            setIsEditStatusModalOpen(false);
            setStatusToAdd("");
            loadOrder();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setEditStatusHistory(false);
        }
    }

    const deleteWorkType = async (associationId: string) => {
        try {
            await privateApi.delete(`/cr-order-manager/v1/order/${orderId}/workType/${associationId}`);
            loadOrder();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setEditWorkTypes(false);
        }
    }

    const deletePayment = async (paymentId: string) => {
        try {
            await privateApi.delete(`/cr-order-manager/v1/payment/${paymentId}`);
            loadOrder();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setEditPayments(false);
        }
    }

    const deleteReplacement = async (associationId: string) => {
        try {
            await privateApi.delete(`/cr-order-manager/v1/order/${orderId}/replacement/${associationId}`);
            loadOrder();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setEditReplacements(false);
        }
    }

    const deleteStatus = async (associationId: string) => {
        try {
            await privateApi.delete(`/cr-order-manager/v1/order/${orderId}/status/${associationId}`);
            loadOrder();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setEditStatusHistory(false);
        }
    }

    const deleteOrder = async (orderId: string) => {
        try {
            await privateApi.delete(`/cr-order-manager/v1/order/${orderId}`);
            navigate('/order');
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    useEffect(() => {
        loadOrder();
        loadWorkTypes();
        loadPaymentTypes();
        loadStatuses();
    }, []);

    const navigate = useNavigate();
    return (
        <>
            <Sidebar/>
            <main className="ml-64 p-6">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-2xl font-bold">Vista Ordine</h1>
                    <div className="flex items-center gap-2">
                        <WhatsappButton options={[
                            {
                                label: "Apri contatto",
                                href: `https://web.whatsapp.com/send/?phone=${order?.customer?.phonePrefix}${order?.customer?.phoneNumber}`
                            }
                        ]}/>
                        <PrintReceiptButton order={order}/>
                        <DeleteButton onClick={() => {
                            setIsDeleteModalOpen(true)
                        }}/>
                        {isDeleteModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                <div className="bg-white rounded-xl p-6 w-full max-w-md">
                                    <span>Sei sicuro di voler eliminare l'ordine?</span>

                                    <div className="flex justify-end gap-2 mt-4">
                                        <button
                                            onClick={() => {
                                                setIsDeleteModalOpen(false);
                                            }}
                                            className="px-4 py-2 bg-gray-200 rounded"
                                        >
                                            Annulla
                                        </button>
                                        <DeleteButton onClick={() => {
                                            deleteOrder(order?.orderId ?? "");
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="mb-6 bg-white p-4 rounded-xl shadow">
                    <div className="flex items-center justify-between">
                        <h2 className="font-semibold">Informazioni cliente</h2>
                    </div>
                    <label className="block mt-4 text-sm font-medium text-gray-700">Nome e Cognome</label>
                    <input disabled={true}
                           placeholder={"Nome"}
                           onClick={() => {
                               // localStorage.setItem("focus", "clienti")
                               navigate(`/customer/${order?.customer?.name}`)
                           }}
                           value={orderIsLoading ? "Caricamento..." : order?.customer?.name + " " + order?.customer?.surname}
                           className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>

                    <label className="block mt-4 text-sm font-medium text-gray-700">Numero di telefono</label>
                    <input disabled={true} placeholder={"Numero di telefono"}
                           value={orderIsLoading ? "Caricamento..." : "+" + order?.customer?.phonePrefix + " " + order?.customer?.phoneNumber}
                           className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>

                <div className="mb-6 bg-white p-4 rounded-xl shadow">
                    <div className="flex items-start justify-between">
                        <h2 className="font-semibold">Informazioni ordine</h2>

                        <div className="flex gap-8 text-sm">
                            <div className="flex flex-col items-end">
                                <span className="text-gray-500">Importo totale</span>
                                <span className="font-medium">€ {order?.replacements
                                    .reduce((total, replacement) => total + replacement.amount, 0)
                                    .toFixed(2)}</span>
                            </div>

                            <div className="flex flex-col items-end">
                                <span className="text-gray-500">Importo versato</span>
                                <span className="font-medium">€ {order?.payments
                                    .reduce((total, payment) => total + payment.amount, 0)
                                    .toFixed(2)}</span>
                            </div>

                            <div className="flex flex-col items-end">
                                <span className="text-gray-500">Saldo residuo</span>
                                <span className="font-semibold text-gray-800">€ {(
                                    (order?.replacements.reduce(
                                        (total, replacement) => total + replacement.amount, 0
                                    ) || 0)
                                    -
                                    (order?.payments.reduce(
                                        (total, payment) => total + payment.amount, 0
                                    ) || 0)
                                ).toFixed(2)}</span>
                            </div>
                        </div>
                    </div>

                    <div className="mb-6 bg-white p-4 rounded-xl shadow mt-4">
                        <div className="flex items-center justify-between">
                            <h2 className="font-semibold">Dispositivo</h2>
                        </div>
                        <label className="block mt-4 text-sm font-medium text-gray-700">Modello</label>
                        <input disabled={true}
                               placeholder={"Modello"}
                               value={orderIsLoading ? "Caricamento..." : order?.device?.brand + " " + order?.device?.model}
                               className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                        <label className="block mt-4 text-sm font-medium text-gray-700">Descrizione</label>
                        <input disabled={true}
                               placeholder={"Descrizione"}
                               value={orderIsLoading ? "Caricamento..." : order?.description}
                               className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                    </div>

                    <div className="mb-6 bg-white p-4 rounded-xl shadow">
                        <div className="flex items-center justify-between">
                            <h2 className="font-semibold">Lavorazioni</h2>
                            <div className="flex justify-end gap-2">
                                {editWorkTypes &&
                                    (<AddButton onClick={() => {
                                        setIsWorkTypeModalOpen(true);
                                    }}/>)}
                                {editWorkTypes && (
                                    <button onClick={() => {
                                        setEditWorkTypes(false)
                                    }}
                                            className="px-4 py-2 bg-gray-200 rounded">
                                        Chiudi
                                    </button>
                                )}
                                {!editWorkTypes &&
                                    (<EditButton onClick={() => setEditWorkTypes(!editWorkTypes)}/>)
                                }
                            </div>
                        </div>

                        <div className="overflow-x-auto mt-4">
                            <table className="w-full text-sm text-left">
                                <thead className="text-gray-500 border-b">
                                <tr>
                                    <th className="py-2">ID</th>
                                    <th className="py-2">Lavorazione</th>
                                    {editWorkTypes && (
                                        <th className="py-2">Azioni</th>
                                    )}
                                </tr>
                                </thead>

                                <tbody className="divide-y">
                                {orderIsLoading ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Caricamento...
                                        </td>
                                    </tr>
                                ) : order?.workTypes?.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Nessuna lavorazione trovata
                                        </td>
                                    </tr>
                                ) : (
                                    order?.workTypes?.map((o) => (
                                        <tr key={o.associationId} className="hover:bg-gray-50">
                                            <td className="py-2">{o.associationId}</td>
                                            <td>{o.workType}</td>
                                            {editWorkTypes && (
                                                <DeleteButton onClick={() => {
                                                    deleteWorkType(o.associationId)
                                                }}/>
                                            )}
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>

                        {isWorkTypeModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                <div className="bg-white rounded-xl p-6 w-full max-w-md">
                                    <h2 className="text-xl font-bold mb-4">
                                        Aggiungi lavorazione
                                    </h2>

                                    <div className="space-y-3">
                                        <select className="w-full border p-2 rounded"
                                                value={workTypeToAdd}
                                                onChange={(e) => {
                                                    setWorkTypeToAdd(e.target.value);
                                                }}>
                                            <option key="" value="">-- Seleziona una lavorazione --</option>
                                            {workTypes.map((workType: WorkTypeObject) => {
                                                return (<option key={workType.id}
                                                                value={workType.id}>{workType.name}</option>)
                                            })}
                                        </select>
                                    </div>

                                    <div className="flex justify-end gap-2 mt-4">
                                        <button
                                            onClick={() => {
                                                setIsWorkTypeModalOpen(false);
                                                setEditWorkTypes(false);
                                                setWorkTypeToAdd("");
                                            }}
                                            className="px-4 py-2 bg-gray-200 rounded"
                                        >
                                            Annulla
                                        </button>
                                        <button
                                            onClick={() => {
                                                addWorkTypeToOrder();
                                            }}
                                            className="px-4 py-2 bg-blue-900 text-white rounded"
                                        >
                                            Salva
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="mb-6 bg-white p-4 rounded-xl shadow">
                        <div className="flex items-center justify-between">
                            <h2 className="font-semibold">Pagamenti</h2>
                            <div className="flex justify-end gap-2">
                                {editPayments &&
                                    (<AddButton onClick={() => {
                                        setIsEditPaymentModalOpen(true);
                                    }}/>)}
                                {editPayments && (
                                    <button onClick={() => {
                                        setEditPayments(false)
                                    }}
                                            className="px-4 py-2 bg-gray-200 rounded">
                                        Chiudi
                                    </button>
                                )}
                                {!editPayments &&
                                    (<EditButton onClick={() => setEditPayments(!editPayments)}/>)
                                }
                            </div>

                        </div>
                        <div className="overflow-x-auto mt-4">
                            <table className="w-full text-sm text-left">
                                <thead className="text-gray-500 border-b">
                                <tr>
                                    <th className="py-2">ID</th>
                                    <th className="py-2">Tipologia</th>
                                    <th className="py-2">Ammontare</th>
                                    <th className="py-2">Data</th>
                                    {editPayments && (
                                        <th className="py-2">Azioni</th>
                                    )}
                                </tr>
                                </thead>

                                <tbody className="divide-y">
                                {orderIsLoading ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Caricamento...
                                        </td>
                                    </tr>
                                ) : order?.payments?.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Nessun pagamento trovato
                                        </td>
                                    </tr>
                                ) : (
                                    order?.payments?.map((o) => (
                                        <tr key={o.paymentId} className="hover:bg-gray-50">
                                            <td className="py-2">{o.paymentId}</td>
                                            <td>{o.paymentType}</td>
                                            <td>€ {o.amount}</td>
                                            <td><DateTimeSpan date={o.creationTimestamp}/></td>
                                            {editPayments && (
                                                <td><DeleteButton onClick={() => {
                                                    deletePayment(o.paymentId)
                                                }}/></td>
                                            )}
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>

                        {isEditPaymentModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                <div className="bg-white rounded-xl p-6 w-full max-w-md">
                                    <h2 className="text-xl font-bold mb-4">
                                        Aggiungi pagamento
                                    </h2>

                                    <div className="space-y-3">
                                        <select className="w-full border p-2 rounded"
                                                value={paymentTypeToAdd}
                                                onChange={(e) => {
                                                    setPaymentTypeToAdd(e.target.value);
                                                }}>
                                            <option key="" value="">-- Seleziona tipologia pagamento --</option>
                                            {paymentTypes.map((paymentType: string) => {
                                                return (<option key={paymentType}
                                                                value={paymentType}>{paymentType}</option>)
                                            })}
                                        </select>
                                        <PriceInput value={paymentAmountToAdd} onChange={setPaymentAmountToAdd}/>
                                    </div>

                                    <div className="flex justify-end gap-2 mt-4">
                                        <button
                                            onClick={() => {
                                                setIsEditPaymentModalOpen(false);
                                                setEditPayments(false);
                                                setPaymentTypeToAdd("");
                                                setPaymentAmountToAdd("");
                                            }}
                                            className="px-4 py-2 bg-gray-200 rounded"
                                        >
                                            Annulla
                                        </button>
                                        <button
                                            onClick={() => {
                                                addPaymentToOrder();
                                            }}
                                            className="px-4 py-2 bg-blue-900 text-white rounded"
                                        >
                                            Salva
                                        </button>
                                    </div>

                                    <span>(*) Campo obbligatorio</span>
                                </div>
                            </div>
                        )}

                    </div>

                    <div className="mb-6 bg-white p-4 rounded-xl shadow">
                        <div className="flex items-center justify-between">
                            <h2 className="font-semibold">Ricambi</h2>
                            <div className="flex justify-end gap-2">
                                {editReplacements &&
                                    (<AddButton onClick={() => {
                                        loadReplacements();
                                        setIsEditReplacementModalOpen(true);
                                    }}/>)}
                                {editReplacements && (
                                    <button onClick={() => {
                                        setEditReplacements(false)
                                    }}
                                            className="px-4 py-2 bg-gray-200 rounded">
                                        Chiudi
                                    </button>
                                )}
                                {!editReplacements &&
                                    (<EditButton onClick={() => setEditReplacements(!editReplacements)}/>)
                                }
                            </div>
                        </div>

                        <div className="overflow-x-auto mt-4">
                            <table className="w-full text-sm text-left">
                                <thead className="text-gray-500 border-b">
                                <tr>
                                    <th className="py-2">ID</th>
                                    <th className="py-2">Ricambio</th>
                                    <th className="py-2">Costo</th>
                                    {editReplacements && (
                                        <th className="py-2">Azioni</th>
                                    )}
                                </tr>
                                </thead>

                                <tbody className="divide-y">
                                {orderIsLoading ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Caricamento...
                                        </td>
                                    </tr>
                                ) : order?.replacements?.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Nessun ricambio trovato
                                        </td>
                                    </tr>
                                ) : (
                                    order?.replacements?.map((o) => (
                                        <tr key={o.associationId} className="hover:bg-gray-50">
                                            <td className="py-2">{o.associationId}</td>
                                            <td>{o.description}</td>
                                            <td>€ {o.amount}</td>
                                            {editReplacements && (
                                                <DeleteButton onClick={() => {
                                                    deleteReplacement(o.associationId)
                                                }}/>
                                            )}
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>

                        {isEditReplacementModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                <div className="bg-white rounded-xl p-6 w-full max-w-md">
                                    <h2 className="text-xl font-bold mb-4">
                                        Aggiungi ricambio
                                    </h2>

                                    <div className="space-y-3">
                                        <select className="w-full border p-2 rounded"
                                                value={replacementToAdd}
                                                onChange={(e) => {
                                                    setReplacementToAdd(e.target.value);
                                                }}>
                                            <option key="" value="">-- Seleziona un ricambio --</option>
                                            {replacements.map((replacement: ReplacementObject) => {
                                                return (<option key={replacement.id}
                                                                value={replacement.id}>{replacement.description}</option>)
                                            })}
                                        </select>
                                    </div>

                                    <div className="flex justify-end gap-2 mt-4">
                                        <button
                                            onClick={() => {
                                                setIsEditReplacementModalOpen(false);
                                                setEditReplacements(false);
                                                setReplacementToAdd("");
                                            }}
                                            className="px-4 py-2 bg-gray-200 rounded"
                                        >
                                            Annulla
                                        </button>
                                        <button
                                            onClick={() => {
                                                addReplacementToOrder();
                                            }}
                                            className="px-4 py-2 bg-blue-900 text-white rounded"
                                        >
                                            Salva
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="mb-6 bg-white p-4 rounded-xl shadow">
                        <div className="flex items-center justify-between">
                            <h2 className="font-semibold">Storico stati</h2>
                            <div className="flex justify-end gap-2">
                                {editStatusHistory &&
                                    (<AddButton onClick={() => {
                                        setIsEditStatusModalOpen(true);
                                    }}/>)}
                                {editStatusHistory && (
                                    <button onClick={() => {
                                        setEditStatusHistory(false)
                                    }}
                                            className="px-4 py-2 bg-gray-200 rounded">
                                        Chiudi
                                    </button>
                                )}
                                {!editStatusHistory &&
                                    (<EditButton onClick={() => setEditStatusHistory(!editStatusHistory)}/>)
                                }
                            </div>
                        </div>

                        <div className="overflow-x-auto mt-4">
                            <table className="w-full text-sm text-left">
                                <thead className="text-gray-500 border-b">
                                <tr>
                                    <th className="py-2">ID</th>
                                    <th className="py-2">Stato</th>
                                    <th className="py-2">Data</th>
                                    {editStatusHistory && (
                                        <th className="py-2">Azioni</th>
                                    )}
                                </tr>
                                </thead>

                                <tbody className="divide-y">
                                {orderIsLoading ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Caricamento...
                                        </td>
                                    </tr>
                                ) : order?.statusHistory?.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Nessuno stato trovato
                                        </td>
                                    </tr>
                                ) : (
                                    order?.statusHistory?.map((o) => (
                                        <tr key={o.associationId} className="hover:bg-gray-50">
                                            <td className="py-2">{o.associationId}</td>
                                            <td><OrderStatusSpan status={o.status}/></td>
                                            <td><DateTimeSpan date={o.creationTimestamp}/></td>
                                            {(editStatusHistory && isStatusEditable(o.creationTimestamp)) && (
                                                <DeleteButton onClick={() => {
                                                    deleteStatus(o.associationId)
                                                }}/>
                                            )}
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>

                        {isEditStatusModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                <div className="bg-white rounded-xl p-6 w-full max-w-md">
                                    <h2 className="text-xl font-bold mb-4">
                                        Aggiungi stato
                                    </h2>

                                    <div className="space-y-3">
                                        <select className="w-full border p-2 rounded"
                                                value={statusToAdd}
                                                onChange={(e) => {
                                                    setStatusToAdd(e.target.value);
                                                }}>
                                            <option key="" value="">-- Seleziona uno stato --</option>
                                            {statuses.map((status: StatusInfo) => {
                                                return (<option key={status.id}
                                                                value={status.id}>{status.name}</option>)
                                            })}
                                        </select>
                                    </div>

                                    <div className="flex justify-end gap-2 mt-4">
                                        <button
                                            onClick={() => {
                                                setIsEditStatusModalOpen(false);
                                                setEditStatusHistory(false);
                                                setStatusToAdd("");
                                            }}
                                            className="px-4 py-2 bg-gray-200 rounded"
                                        >
                                            Annulla
                                        </button>
                                        <button
                                            onClick={() => {
                                                addStatusToOrder();
                                            }}
                                            className="px-4 py-2 bg-blue-900 text-white rounded"
                                        >
                                            Salva
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </>
    );
}

export default OrderView;